import React from 'react';
import { ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { IMAGES } from '../data/audit';
const stats = [{
  value: '6',
  label: 'Professional Audit Volumes'
}, {
  value: '5',
  label: 'Bonuses'
}, {
  value: '30+',
  label: 'Clinical Audit Tools'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-navy-950 pb-14 pt-8 sm:pb-20 sm:pt-12" data-id="element-199" data-mp="1285x3nzc5smb">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gold-500/40" aria-hidden="true" data-id="element-200" data-mp="xbpcv4v9byei" />
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-201" data-mp="sde0onhhpbt4">
        <div className="flex flex-col items-center gap-2 text-center" data-id="element-202" data-mp="nb6njukxbpp7">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold-500/40 bg-gold-500/10 px-3.5 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.16em] text-gold-300 sm:text-[11px]" data-id="element-203" data-mp="3d21sryrtemo9">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-204" data-mp="3j897lcz58bpj" />
            Created by Dr. Karito
          </span>
        </div>

        <h1 className="mx-auto mt-6 max-w-4xl text-center font-display text-[32px] font-bold leading-[1.08] text-cream-50 sm:text-5xl lg:text-6xl" data-id="element-205" data-mp="3o6u7fbahgtdg">
          Complex Rehab{' '}
          <span className="text-gold-400" data-id="element-206" data-mp="3e84orgarj4w5">Case Audit™</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-center text-sm font-bold uppercase tracking-[0.12em] text-gold-300 sm:text-base" data-id="element-207" data-mp="30hho3ilfz4xf">
          The 15-minute clinical review system for complex rehabilitation cases
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-cream-100/80 sm:text-lg" data-id="element-208" data-mp="2ql6ampa4891e">
          Audit the <strong className="font-bold text-cream-50" data-id="element-209" data-mp="2vj7sx7zpw4bt">7 critical areas</strong> of a
          complex rehabilitation case in 15 minutes — so you know what deserves a
          closer look before moving forward.
        </p>

        <div className="mx-auto mt-8 w-full max-w-4xl" data-id="element-210" data-mp="s21h48i0i7ye">
          <img src={IMAGES.productStack} alt="The complete Complex Rehab Case Audit™ system: six audit volumes, tablet edition, worksheets and five bonus resources" className="w-full" loading="eager" data-id="element-211" data-mp="s2tbjfzvhzn3" />
        </div>

        <div className="mx-auto mt-6 grid w-full max-w-2xl grid-cols-3 gap-2 sm:gap-4" data-id="element-212" data-mp="ddwy13f1ruf3">
          {stats.map(s => <div key={s.label} className="rounded-2xl border border-white/10 bg-white/5 px-2 py-4 text-center sm:px-4" data-id="element-213" data-mp="1azkvzsr5iksq">
              <div className="font-display text-2xl font-bold text-gold-400 sm:text-3xl" data-id="element-214" data-mp="112g89ohnqh9t">
                {s.value}
              </div>
              <div className="mt-1 text-[10px] font-semibold uppercase leading-tight tracking-[0.08em] text-cream-100/70 sm:text-[11px]" data-id="element-215" data-mp="x0cs4mk1moi7">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="mt-9 flex flex-col items-center gap-6" data-id="element-216" data-mp="3htga4a18inje">
          <CTAButton id="hero-cta" label="Get the Complex Rehab Case Audit™" subLabel="Instant access · One-time payment · Lifetime access · 7-day guarantee" variant="gold" data-id="element-217" data-mp="1xam72v6j3z11" />
          <Countdown tone="light" data-id="element-218" data-mp="267wjwkyzvw82" />
          <ScarcityBar tone="light" data-id="element-219" data-mp="2b195sncahox4" />
          <p className="flex items-center gap-2 text-xs font-semibold text-cream-100/60" data-id="element-220" data-mp="2b2ai0v51khgf">
            <ShieldCheckIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-221" data-mp="2fz0w5cxad2z7" />
            Secure checkout · Automatic currency conversion
          </p>
        </div>
      </div>
    </section>;
}